import type { ComponentPropsWithoutRef } from 'react'

const ModalList = ({ className = '', ...props }: ComponentPropsWithoutRef<'ul'>) => (
  <ul className={`h-full w-full divide-y divide-gray-500 overflow-x-hidden overflow-y-scroll border border-gray-500 ${className}`} {...props} />
)

export default ModalList
